import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import style from "./DashboardSidebar.module.css";
import { Link } from 'react-router-dom';
import { logout_Api, current_user_Api } from '../../dashboardapi';
import { useNavigate } from 'react-router-dom';
import { Spinner, useToast } from '@chakra-ui/react';
import templatestyle from "./TemplateModal.module.css";
import { create_environment_Api, create_environment_file_Api, get_all_environment_Api } from '../../dashboardapi';
import dashboardmodal from "./ModalStyles.module.css"
import DashboardThemes from './DashboardThemes';
import { useTheme } from '../../Themes/ThemeContext';
import Modal from './Modal';
import { useDispatch } from 'react-redux';
import ManageStyles from './ManageStyles';
import UploadManager from "../../components/UploadManager";
import { removeToken } from '../../Utils/authUtils';
import { MAX_FILE_SIZE_KB, MAX_FILE_SIZE_MSG } from '../../Utils/constants';


// const DashboardSidebar = () => {
const DashboardSidebar = ({ ToogleSidebars }) => {
    const [toogleAccount, setToogleAccount] = useState(false);
    const [toggleSettings, setToggleSettings] = useState(false);
    const [toogleThemeChoose, setToogleThemeChoose] = useState(false);
    const [choosedTheme, setChoosedTheme] = useState();
    const [clickedTheme, setClickedTheme] = useState();
    const [showTheme, setShowTheme] = useState(false);
    const [render, setRender] = useState(false);
    // const [showModal, setShowModal] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [projId, setProjId] = useState("");
    const [showUploadManager, setShowUploadManager] = useState(false);   //upload manager trigger
    const [fileUploadShow, setFileUploadShow] = useState(false);    //  modal structure trigger
    const [showSignoutModal, setShowSignOutModal] = useState(false);
    const [userDetails, setUserDetails] = useState("");
    const [AccountModal, setAccountModal] = useState(false);
    const [SettingsModal, setSettingsModal] = useState(false);
    const toast = useToast();
    const Templatenavigate = useNavigate();
    const [accountActive, setAccountActive] = useState("");
    const popupref = useRef();
    const accountref = useRef();
    const createTemplateRef = useRef();
    const signoutref = useRef();
    const profileref = useRef();
    const manageRef = useRef();


    const dispatch = useDispatch()
    const [TemplateactiveTab, TemplateSetActiveTab] = useState("upload")
    const [showtemplatemodal, setshowtemplatemodal] = useState(false);
    const [TemplateenvironmentTitle, TemplatesetEnvironmentTitle] = useState("")
    const TemplatefileInputRef = useRef(null);
    const [Templatedragging, TemplatesetDragging] = useState(false);
    const [Templateshow, TemplatesetShow] = useState(false);
    const [TemplateinputFiles, TemplatesetInputFiles] = useState([]);
    const [Templateenvironments, TemplatesetEnvironments] = useState();
    const [TemplateshowDetails, TemplatesetShowDetails] = useState({ show: false, env: "", id: "" })
    const [Templateuserdetail, TemplatesetUserDetail] = useState("");
    const [isMobile, setIsMobile] = useState(false);

    const { theme, toggleTheme, newavailableThemes } = useTheme();
    console.log("the current theme in the editor is :", theme, newavailableThemes);
    useEffect(() => { setChoosedTheme(newavailableThemes[0]) }, [theme])




    useEffect(() => {
        function closeaccountmodal(e) {
            if (AccountModal && profileref.current && !profileref.current.contains(e.target)) {
                setAccountModal(false);
                setClickedTheme("")
            }
        }
        document.addEventListener('mousedown', closeaccountmodal);
        return () => document.removeEventListener('mousedown', closeaccountmodal);
    }, [AccountModal])

    useEffect(() => {
        function closemanagestyle(e) {
            if (SettingsModal && manageRef.current && !manageRef.current.contains(e.target)) {
                setSettingsModal(false);
            }
        }
        document.addEventListener('mousedown', closemanagestyle);
        return () => {
            document.removeEventListener('mousedown', closemanagestyle);
        };
    }, [SettingsModal]);

    useEffect(() => {
        function closedeleteModal(e) {
            if (showSignoutModal && signoutref.current && !signoutref.current.contains(e.target)) {
                setShowSignOutModal(false);
            }
        }
        document.addEventListener('mousedown', closedeleteModal);
        return () => document.removeEventListener('mousedown', closedeleteModal)

    }, [showSignoutModal])
    const allprojectIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1603_238)">
            <path d="M7.50016 3.3335H10.0002L11.6668 5.00016H15.8335C16.2755 5.00016 16.6994 5.17576 17.012 5.48832C17.3246 5.80088 17.5002 6.2248 17.5002 6.66683V12.5002C17.5002 12.9422 17.3246 13.3661 17.012 13.6787C16.6994 13.9912 16.2755 14.1668 15.8335 14.1668H7.50016C7.05814 14.1668 6.63421 13.9912 6.32165 13.6787C6.00909 13.3661 5.8335 12.9422 5.8335 12.5002V5.00016C5.8335 4.55814 6.00909 4.13421 6.32165 3.82165C6.63421 3.50909 7.05814 3.3335 7.50016 3.3335Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.1667 14.1665V15.8332C14.1667 16.2752 13.9911 16.6991 13.6785 17.0117C13.366 17.3242 12.942 17.4998 12.5 17.4998H4.16667C3.72464 17.4998 3.30072 17.3242 2.98816 17.0117C2.67559 16.6991 2.5 16.2752 2.5 15.8332V8.33317C2.5 7.89114 2.67559 7.46722 2.98816 7.15466C3.30072 6.8421 3.72464 6.6665 4.16667 6.6665H5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1603_238">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

    const sharedProjectsIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1603_39)">
            <path d="M10.8333 15.8335H4.16667C3.72464 15.8335 3.30072 15.6579 2.98816 15.3453C2.67559 15.0328 2.5 14.6089 2.5 14.1668V5.00016C2.5 4.55814 2.67559 4.13421 2.98816 3.82165C3.30072 3.50909 3.72464 3.3335 4.16667 3.3335H7.5L10 5.8335H15.8333C16.2754 5.8335 16.6993 6.00909 17.0118 6.32165C17.3244 6.63421 17.5 7.05814 17.5 7.50016V10.8335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3335 18.3332L17.5002 14.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.5 17.9165V14.1665H13.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1603_39">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

    const TrashedIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1555_4005)">
            <path d="M3.3335 5.8335H16.6668" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.3335 9.1665V14.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.6665 9.1665V14.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.1665 5.8335L4.99984 15.8335C4.99984 16.2755 5.17543 16.6994 5.48799 17.012C5.80055 17.3246 6.22448 17.5002 6.6665 17.5002H13.3332C13.7752 17.5002 14.1991 17.3246 14.5117 17.012C14.8242 16.6994 14.9998 16.2755 14.9998 15.8335L15.8332 5.8335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1555_4005">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

    const projectkidsIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3332 16.6665V3.33317C13.3332 2.89114 13.1576 2.46722 12.845 2.15466C12.5325 1.8421 12.1085 1.6665 11.6665 1.6665H8.33317C7.89114 1.6665 7.46722 1.8421 7.15466 2.15466C6.8421 2.46722 6.6665 2.89114 6.6665 3.33317V16.6665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M16.6665 5H3.33317C2.4127 5 1.6665 5.74619 1.6665 6.66667V15C1.6665 15.9205 2.4127 16.6667 3.33317 16.6667H16.6665C17.587 16.6667 18.3332 15.9205 18.3332 15V6.66667C18.3332 5.74619 17.587 5 16.6665 5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    const ThemeIcons = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1555_4021)">
            <path d="M15.8332 9.16667L9.16653 2.5L1.99987 9.66667C1.69449 9.97821 1.52344 10.3971 1.52344 10.8333C1.52344 11.2696 1.69449 11.6885 1.99987 12L6.3332 16.3333C6.99987 17 7.99987 17 8.66653 16.3333L15.8332 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.1665 1.6665L8.33317 5.83317" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1.6665 10.8335H14.1665" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18.3333 16.6668C18.3333 17.1089 18.1577 17.5328 17.8452 17.8453C17.5326 18.1579 17.1087 18.3335 16.6667 18.3335C16.2246 18.3335 15.8007 18.1579 15.4882 17.8453C15.1756 17.5328 15 17.1089 15 16.6668C15 15.3335 16.4167 14.6668 16.6667 13.3335C16.9167 14.6668 18.3333 15.3335 18.3333 16.6668Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1555_4021">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>




    const links = [
        { title: "All Projects", icon: allprojectIcon, url: '/dashboard/myprojects' },
        { title: "Shared Projects", icon: sharedProjectsIcon, url: '/dashboard/sharedprojects' },
        { title: "Trashed", icon: TrashedIcon, url: '/dashboard/trashedprojects' },
        { title: "Project kits", icon: projectkidsIcon, url: '/dashboard/dashboardTemplate' },
        // { title: "Themes", icon: ThemeIcons, url: "" }

    ];
    const TemplatehandleSignOut = async (e) => {
        let response = await logout_Api();
        console.log(response)

        if (response.data) {
            removeToken()
            Templatenavigate("/loginnew/signIn")
            toast({
                title: "Signed Out Successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
        } else {
            toast({
                title: "Problem signing out",
                description: "Please try again later",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }
    useEffect(() => {
        function handleClickOutside(e) {
            if (toogleThemeChoose && popupref.current && !popupref.current.contains(e.target)) {
                setToogleThemeChoose(false)
                console.log("clicked the outside", toogleThemeChoose ? 1 : 0)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [toogleThemeChoose]);

    useEffect(() => {
        function closeCreateTemplate(e) {
            if (showTemplateModal && createTemplateRef.current && !createTemplateRef.current.contains(e.target)) {
                setShowTemplateModal(false)
            }
        }
        document.addEventListener("mousedown", closeCreateTemplate);
        return () => document.removeEventListener("mousedown", closeCreateTemplate);
    }, [showTemplateModal]);


    useEffect(() => {
        function handleaccountOutside(e) {
            if (toogleAccount && accountref.current && !accountref.current.contains(e.target)) {
                setToogleAccount(false)
            }
        }
        document.addEventListener("mousedown", handleaccountOutside);
        return () => document.removeEventListener("mousedown", handleaccountOutside)

    }, [toogleAccount]);



    useEffect(() => {
        let details = async () => {
            try {
                let result = await current_user_Api();
                if (result.data) {
                    setUserDetails(result.data.message)
                }
            } catch (error) {
                console.log(error);
            }
        }
        details();
    }, [])
    useEffect(() => {
        TemplatefetchEnvironemnt()
    }, [])

    const TemplatefetchEnvironemnt = async () => {
        let result = await get_all_environment_Api();
        if (result.data) {
            TemplatesetEnvironments(result.data)
        } else {
            const error = result.error.Message || "An error Occured";
            toast({
                title: "Problem getting Templates",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }



    const TemplatehandleDragOver = (e) => {
        e.preventDefault();
        TemplatesetDragging(true); // Highlight the area when dragging files
    };

    const TemplatehandleDragLeave = () => {
        TemplatesetDragging(false); // Remove highlight when leaving
    };

    const TemplatehandleDrop = (e) => {
        e.preventDefault();
        TemplatesetDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        TemplatehandleFiles(files); // Handle dropped files
    };

    const TemplatehandleFiles = (files) => {
        let size = MAX_FILE_SIZE_KB;
        let allowedfiles = [];
        let count = 0;
        const fileslist = Array.from(files)
        for (let n of fileslist) {
            count += (n.size * 0.001)
            if (count < size) {
                allowedfiles.push(n)
                console.log(count);
            }
        }
        if (fileslist.length !== allowedfiles.length) {
            toast({
                title: MAX_FILE_SIZE_MSG,
                description: "",
                duration: "2000",
                status: "warning",
                isClosable: "true"
            })
        }
        TemplatesetInputFiles(prevFiles => [...prevFiles, ...allowedfiles]);

        // TemplatesetInputFiles(allowedfiles)
    };
    // console.log(TemplateinputFiles);
    const TemplatehandleClick = () => {
        TemplatefileInputRef.current.click(); // Trigger file input click
    };

    const TemplatehandleChange = (e) => {
        TemplatesetEnvironmentTitle(e.target.value)
    }

    const TemplatecreateFile = async (e) => {
        e.preventDefault();
        let result = await create_environment_Api(TemplateenvironmentTitle)
        if (result.data) {
            toast({
                title: "Environment created successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            });
            dispatch({ type: "Triggered" })
            setShowTemplateModal(false)
            setProjId(result.data.uuid);

            // console.log(TemplateinputFiles);
            if (TemplateinputFiles.length > 0) {
                setFileUploadShow(true);
                setShowUploadManager(true);
                TemplatefetchEnvironemnt();
            } else {
                setshowtemplatemodal(false);
                TemplatefetchEnvironemnt();
            }
        } else {
            const errorMessage = result.error.message || "An error occurred.";
            toast({
                title: "Problem getting files",
                description: errorMessage,
                status: "error",
                duration: 2000,
                isClosable: "true"
            });
        }
        // TemplatesetInputFiles([]);
    };



    const TemplatehandleDelete = (todelete) => {
        TemplatesetInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const TemplateshowEnvDetails = (env, i) => {
        TemplatesetShowDetails({ show: true, env: env, id: i })
    }


    return (
        <div className={style.SidebarContainer}>
            <div className={style.dashboardFirsthalf}>
                <div className={style.dashboardroutes}>
                    {links.map((item, index) => (
                        <>
                            {
                                item.title === "Themes" ? (
                                    <div ref={popupref} style={{ position: "relative" }}>
                                        <button
                                            className={style.linkItem}
                                            onClick={() => {
                                                setRender(r => !r);
                                                // ToogleSidebars(false);
                                                setToogleThemeChoose(prev => !prev)

                                            }}
                                        >
                                            <item.icon />
                                            <p>{theme === "light" ? "Light Theme" : theme === "dark" ? "Dark Theme" : theme === "blue" ? "Theme 1" : theme === "green" ? "Theme 2" : theme === "black" ? "Theme 3" : "Themes"}</p>

                                        </button>
                                        {
                                            toogleThemeChoose && (

                                                <DashboardThemes setTheme={setToogleThemeChoose} />


                                            )

                                        }
                                    </div>
                                ) : (

                                    <NavLink
                                        key={index}
                                        to={item.url}
                                        className={({ isActive }) =>
                                            isActive ? `${style.linkItem} ${style.activeLink}` : style.linkItem
                                        }
                                        onClick={() => {
                                            setRender(r => !r);
                                            if (window.innerWidth < 769) {
                                                ToogleSidebars(false);
                                            }
                                            // ToogleSidebars(false);
                                        }}
                                    >
                                        <item.icon />
                                        <p>{item.title}</p>
                                        <div></div>
                                    </NavLink>

                                )
                            }
                        </>

                    ))}

                </div>

                <hr className={style.dashboarddividerhr} />
                <div className={style.dashboardTemplate}>
                    <p className={style.templateHeading}>Templates</p>
                    <button className={style.createButton} onClick={() => setShowTemplateModal(true)} aria-label="Create your own template">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.1665 10H15.8332" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 4.1665V15.8332" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        Create your own</button>

                    {/* <button className={style.browseButton} > */}
                    <Link to={"/templates"} aria-label="Browse Templates" className={style.browseButton}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9.99984 1.6665C7.86003 3.9133 6.6665 6.89712 6.6665 9.99984C6.6665 13.1026 7.86003 16.0864 9.99984 18.3332C12.1396 16.0864 13.3332 13.1026 13.3332 9.99984C13.3332 6.89712 12.1396 3.9133 9.99984 1.6665Z" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1.6665 10H18.3332" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        Browse Template
                    </Link>

                    {/* </button> */}
                </div>
            </div>
            <Modal show={showTemplateModal}>
                <div ref={createTemplateRef} className={dashboardmodal.modalboxContainer}>
                    <div className={dashboardmodal.modalheadingContainer}>
                        <p>Create Your Own Template</p>
                        <button onClick={() => setShowTemplateModal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </button>
                    </div>
                    <div className={dashboardmodal.modalContentContainer}>
                        <form className={dashboardmodal.formouter} method="POST" onSubmit={TemplatecreateFile}>
                            <div className={dashboardmodal.inputdiv}>
                                <div className={dashboardmodal.inputWrapper}>
                                    <label>
                                        Template Name <span className={dashboardmodal.required}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="environment_name"
                                        onChange={TemplatehandleChange}
                                        maxLength={50}
                                        placeholder="Enter Environment Name"
                                        required
                                    />
                                </div>

                                {/* FILE UPLOAD BOX */}
                                <div
                                    className={`${dashboardmodal.uploadBox} ${Templatedragging ? dashboardmodal.dragging : ""}`}
                                    onDragOver={TemplatehandleDragOver}
                                    onDragLeave={TemplatehandleDragLeave}
                                    onDrop={TemplatehandleDrop}
                                >
                                    {!Templatedragging && (
                                        <>
                                            <button aria-label='upload files' type='button' onClick={TemplatehandleClick}>
                                                <div className={dashboardmodal.uploadicon}>
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.6665 13.3333L9.99984 10M9.99984 10L13.3332 13.3333M9.99984 10V17.5M16.6665 13.9524C17.6844 13.1117 18.3332 11.8399 18.3332 10.4167C18.3332 7.88536 16.2811 5.83333 13.7498 5.83333C13.5677 5.83333 13.3974 5.73833 13.3049 5.58145C12.2182 3.73736 10.2119 2.5 7.9165 2.5C4.46472 2.5 1.6665 5.29822 1.6665 8.75C1.6665 10.4718 2.36271 12.0309 3.48896 13.1613" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </button>



                                            <div className={templatestyle.uploadDashboardfile}>


                                                <p> <span> <a onClick={TemplatehandleClick}>Click to Upload</a></span> or drag and drop your files here or</p>
                                            </div>


                                            <input
                                                type="file"
                                                ref={TemplatefileInputRef}
                                                style={{ display: "none" }}
                                                multiple
                                                onChange={(e) => TemplatehandleFiles(e.target.files)}
                                            />
                                        </>
                                    )}

                                    {Templatedragging && <div className={dashboardmodal.dragText}>Drag your file here</div>}
                                </div>

                                {/* SHOW SELECTED FILES IF ANY */}
                                {/* <div className={dashboardmodal.selectedList}>
                                 */}
                                <div>
                                    {TemplateinputFiles.map((file, id) => (
                                        <div key={id} className={dashboardmodal.fileItem}>
                                            <span>
                                                <p>{file.name}</p>
                                                <p className={dashboardmodal.fileMeta}>
                                                    {file.type} | {(file.size / 1024).toFixed(2)} kb
                                                </p>
                                            </span>
                                            <button onClick={() => TemplatehandleDelete(file.name)}>Delete</button>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className={dashboardmodal.actionbtn}>
                                <button
                                    className={dashboardmodal.btn1}
                                    onClick={() => (setShowTemplateModal(!showTemplateModal), TemplatesetInputFiles([]))}
                                >
                                    Cancel
                                </button>
                                <button className={dashboardmodal.btn2} type="submit">
                                    Create
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
            <Modal show={fileUploadShow}>
                <div className={style.modalouter}>
                    {showUploadManager && <div><UploadManager
                        projectId={projId}
                        files={TemplateinputFiles}
                        apiFunc={create_environment_file_Api}
                        onClose={() => {
                            setShowUploadManager(false);
                            setFileUploadShow(false);
                            console.log("closed");
                            TemplatesetInputFiles([]);
                        }}
                    /></div>}
                </div>
            </Modal>

            <div ref={accountref} className={style.accountSectionWrapper}>

                <div className={style.accountSection}>

                    <button
                        className={style.dashboardsidebaraccount}
                        onClick={() => setToogleAccount(prev => !prev)}
                    >
                        <div className={style.accountlogo}>
                            <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/DashboardAccount.svg"} alt='user_icon' />
                            <div>Account</div>
                        </div>

                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 0.75L5.75 5.75L0.75 10.75" stroke="#AEAEAE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        {toogleAccount && (
                            <div className={style.accountDropdown}>
                                <ul>
                                    <li>
                                        <button onClick={() => { setAccountActive("profile"); setAccountModal(true); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M9.99967 10.8333C12.3009 10.8333 14.1663 8.96785 14.1663 6.66667C14.1663 4.36548 12.3009 2.5 9.99967 2.5C7.69849 2.5 5.83301 4.36548 5.83301 6.66667C5.83301 8.96785 7.69849 10.8333 9.99967 10.8333Z" stroke="#F5F5F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M16.6663 17.4987C16.6663 15.7306 15.964 14.0349 14.7137 12.7847C13.4635 11.5344 11.7678 10.832 9.99967 10.832C8.23156 10.832 6.53587 11.5344 5.28563 12.7847C4.03539 14.0349 3.33301 15.7306 3.33301 17.4987" stroke="#F5F5F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            Profile
                                        </button>
                                    </li>
                                    <li >
                                        {/* <li className={accountActive === "signout" ? style.accountoptionactive : style.accountoptioninactive}> */}
                                        <button onClick={() => { setAccountActive("signout"); setShowSignOutModal(true) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M13.333 14.1654L17.4997 9.9987L13.333 5.83203" stroke="#F5F5F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M17.5 10H7.5" stroke="#F5F5F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5" stroke="#F5F5F5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            Sign out
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </button>
                </div>
            </div>

            <Modal show={SettingsModal}>
                <div ref={manageRef} className={templatestyle.warningcontainer}>
                    <div className={templatestyle.TemplateHeaderContainer}>
                        <p >Manage Styles</p>
                        <button onClick={() => setSettingsModal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div>
                        <ManageStyles setSettingsModal={setSettingsModal} />
                    </div>
                </div>
            </Modal>

            <Modal show={showSignoutModal}>
                <div ref={signoutref} className={templatestyle.warningcontainer}>
                    <div className={templatestyle.TemplateHeaderContainer}>
                        <p >Sign Out</p>
                        <button onClick={() => setShowSignOutModal(false)}>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                    </div>

                    <div className={templatestyle.warningContent}>
                        <p>Are your sure. You want to signout?</p>
                    </div>
                    <div className={templatestyle.warningbuttonsection}>
                        <button className={templatestyle.cancelBtn} onClick={() => { setShowSignOutModal(false); setAccountActive("") }} >Cancel</button>
                        <button className={templatestyle.DeleteWarningbtn} onClick={() => { TemplatehandleSignOut(); }}>Signout</button>
                    </div>
                </div>
            </Modal>

            <Modal show={AccountModal}>
                <div ref={profileref} className={templatestyle.warningcontainer}>

                    <div className={templatestyle.TemplateHeaderContainer}>

                        <p>Profile</p>
                        <button onClick={() => { setAccountModal(false); setAccountActive(""); setClickedTheme("") }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className={style.themecontent}>


                        <div className={style.profileContent}>
                            <p className={style.personalDetail}>Personal Details</p>
                            <p className={style.profileEmail}>Email: {userDetails}</p>
                        </div>
                        <div className={style.changeThemebutton}>
                            <div className={style.themebutton}>
                                <p>Theme:</p>

                                <button onClick={() => { toggleTheme(choosedTheme); setAccountModal(false); setAccountActive(""); setClickedTheme("") }}>Change Theme</button>
                            </div>
                            <div className={style.showProfileTheme}>

                                <div className={style.ProfileThemeOption}>
                                    <ul>
                                        {newavailableThemes.map((item, index) => (
                                            <li key={index}>
                                                <button
                                                    onClick={() => {
                                                        setChoosedTheme(item);
                                                        setShowTheme(false);
                                                        setClickedTheme(item);
                                                    }}
                                                >
                                                    {item.name === "Light Mode" ? (
                                                        <div
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                } ${theme === item.value && style.CurrentTheme}`}
                                                        >


                                                            <p>Default</p>
                                                        </div>
                                                    ) : item.name === "Dark Mode" ? (
                                                        <div
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                } ${theme === item.value && style.CurrentThemeDarkMode}`}
                                                        >
                                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_1743_3692)">
                                                                    <path d="M10.0001 2.50007C10.1101 2.50007 10.2193 2.50007 10.3276 2.50007C9.25709 3.49483 8.56897 4.83328 8.38288 6.28276C8.1968 7.73224 8.52453 9.2011 9.30909 10.434C10.0937 11.6669 11.2855 12.5859 12.6773 13.0313C14.0692 13.4767 15.5731 13.4202 16.9276 12.8717C16.4066 14.1255 15.555 15.2143 14.4636 16.022C13.3723 16.8296 12.0822 17.3259 10.7309 17.4579C9.37962 17.5899 8.01786 17.3525 6.79088 16.7712C5.56391 16.1899 4.51774 15.2865 3.76397 14.1572C3.0102 13.028 2.5771 11.7153 2.51088 10.3592C2.44466 9.00312 2.7478 7.65449 3.38795 6.45717C4.02811 5.25985 4.98128 4.25876 6.14578 3.56069C7.31028 2.86261 8.64244 2.49374 10.0001 2.49341V2.50007Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_1743_3692">
                                                                        <rect width="20" height="20" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>

                                                            <p>Dark</p>
                                                        </div>
                                                    ) : item.name === "Theme 1" ? (
                                                        <div
                                                            // className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                            //     }`}
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                } ${theme === item.value && style.CurrentTheme}`}
                                                        >
                                                            <div style={{ background: item.color }} className={style.themechangingoption}></div>
                                                            <p>Deep  Blue</p>
                                                        </div>
                                                    ) : item.name === "Theme 2" ? (
                                                        <div
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                }  ${theme === item.value && style.CurrentTheme}`}
                                                        >
                                                            <div style={{ background: item.color }} className={style.themechangingoption}></div>
                                                            <p>Vibrant Green</p>
                                                        </div>
                                                    ) : item.name === "Theme 3" ? (
                                                        <div
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                } ${theme === item.value && style.CurrentTheme}`}
                                                        >
                                                            <div style={{ background: item.color }} className={style.themechangingoption}></div>
                                                            <p>Steel Gray</p>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={`${style.iconandnamecontainer} ${clickedTheme?.name === item.name ? style.selectedTheme : ""
                                                                } `}
                                                        >
                                                            <div style={{ background: `${item.color}` }} className={style.themechangingoption}></div>
                                                            <p>{item.name}</p>
                                                        </div>
                                                    )}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div >
    );
};

export default DashboardSidebar;
